import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message,Input } from 'antd';
import {closeUpdateLeague} from '../../redux/actions/league/toggleEditLeague';
import {updateLeague} from '../../redux/actions/league/updateLeague';
import {getLeagues} from '../../redux/actions/league/getLeagues';

class UpdateLeagueModal extends React.Component {
    constructor(props){
        super(props);
        this.form=React.createRef();
    }
    layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 12,
        },
    };
    tailLayout = {
        wrapperCol: {
            offset: 12,
            span: 16,
        },
    };
    onFinish = async (values) => {
        await this.props.onUpdate(this.props.id,values.name,this.props.token);
        if(this.props.error){
            message.error(this.props.error);
        }
        if(this.props.message){
            message.success(this.props.message);
            this.props.onGetAll(this.props.token);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Update League"
                key={this.props.match?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-league-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-league-form"
                    {...this.layout}
                    name="basic"
                    initialValues={{

                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.league.updateLeagueVisible,
    loading: state.league.loading,
    token: state.auth.token,
    error:state.league.error,
    message:state.league.message,
    id:state.league.idToUpdate
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (id,name, token) => dispatch(updateLeague(id,name, token)),
    onClose: () => dispatch(closeUpdateLeague()),
    onGetAll: (token) => dispatch(getLeagues(token)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateLeagueModal);